import React from 'react';
import './App.css';

export default function Intro(){

    return(
        <div>
            
            <h1 className=" gap pp">
            Hello there! <br />
            Welcome

            <div className="pp__horizontal"></div>
            <div className="pp__vertical"></div>
            </h1>
            <br/><br/><br/><br/><br/>
            <br/><br/><br/><br/><br/>
            <br/><br/><br/><br/><br/>

        </div>

    )
}
